<template>
  <div class="menu-card" @click="$emit('click')">
    <img class="menu-card__icon" :src="icon" :alt="title" />
    <div class="menu-card__text">
      <span class="typo-md-bold">{{ title }}</span>
      <span class="typo-sm-medium">{{ description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuCard',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.menu-card {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.menu-card__icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.menu-card__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MenuCard.vue